<template>
  <div>
    <el-row>
      <el-col>
        <el-table :data="tableData" size="small" border stripe highlight-current-row
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
          <el-table-column type="index" label="序号" align="center" width="50" min-width="30"></el-table-column>
          <el-table-column prop="orderId" label="订单id" align="center" min-width="160"></el-table-column>
          <el-table-column prop="payAmount" label="支付金额" align="center" min-width="120">
            <template slot-scope="scope">
              {{ (scope.row.payAmount / 100).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="payTime" label="支付时间" align="center" min-width="180"></el-table-column>
          <el-table-column prop="type" label="订单来源" align="center" min-width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.type == 1" type="success">抖店</el-tag>
              <el-tag v-else-if="scope.row.type == 2">快手</el-tag>
              <el-tag v-else type="danger">小红书</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="orderStatus" label="订单状态" align="center" min-width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.orderStatus == 2" type="success">待发货</el-tag>
              <el-tag v-else-if="scope.row.orderStatus == 3">已发货</el-tag>
              <el-tag v-else orderStatus="danger">未知</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="outboundStatus" label="出库状态" align="center" min-width="80">
          </el-table-column>
          <el-table-column prop="expShipTime" label="预计发货时间" align="center" min-width="120"></el-table-column>
          <el-table-column label="产品详情" width="300">
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.skuItemInfoList" :key="index" class="skuList">
                {{ item.productName }} x {{ item.productNum }}
              </div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" align="center" min-width="200px">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="productOutbound(scope.row)"
                v-if="scope.row.outboundStatus == '在库'" style="color: #ebb563">手机出库</el-button>
              <el-button type="text" size="small" @click="accessoryOutbound(scope.row)"
                style="color: #ebb563">配件出库</el-button>
              <el-popconfirm title="确定该订单申请退货？" @confirm="handleConfirm(scope.row)" @cancel="handleCancel">
                <el-button type="text" size="small" slot="reference" v-if="scope.row.outboundStatus == '已出库'"
                  style="color: #ebb563">申请退货</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog @close="handleClose" :title="productOutboundFormTitle" center :visible.sync="productOutboundVisible"
      width="450px" :close-on-click-modal="false">
      <el-form size="small" :model="productOutboundForm" ref="productOutboundForm" :label-width="formLabelWidth">
        <el-form-item label="手机IMEI码1：" prop="SNName1">
          <el-input v-model="productOutboundForm.SNName1" placeholder="请输入手机IMEI码" class="form-inp-width"></el-input>
        </el-form-item>
        <el-form-item label="商品价格：" prop="commodityPrice1">
          <el-input v-model="productOutboundForm.commodityPrice1" placeholder="请输入商品价格"
            class="form-inp-width"></el-input>
        </el-form-item>
        <el-form-item label="手机IMEI码2：" prop="SNName2" v-show="simpleList >= 2
          ">
          <el-input v-model="productOutboundForm.SNName2" placeholder="请输入手机IMEI码" class="form-inp-width"></el-input>
        </el-form-item>
        <el-form-item label="商品价格：" prop="commodityPrice2" v-show="simpleList >= 2">
          <el-input v-model="productOutboundForm.commodityPrice2" placeholder="请输入商品价格"
            class="form-inp-width"></el-input>
        </el-form-item>
        <el-form-item label="手机IMEI码3：" prop="SNName3" v-show="simpleList >= 3">
          <el-input v-model="productOutboundForm.SNName3" placeholder="请输入手机IMEI码" class="form-inp-width"></el-input>
        </el-form-item>
        <el-form-item label="商品价格：" prop="commodityPrice3" v-show="simpleList >= 3">
          <el-input v-model="productOutboundForm.commodityPrice3" placeholder="请输入商品价格"
            class="form-inp-width"></el-input>
        </el-form-item>
        <el-form-item label="手机IMEI码4：" prop="SNName4" v-show="simpleList >= 4">
          <el-input v-model="productOutboundForm.SNName4" placeholder="请输入手机IMEI码" class="form-inp-width"></el-input>
        </el-form-item>
        <el-form-item label="商品价格：" prop="commodityPrice4" v-show="simpleList >= 4">
          <el-input v-model="productOutboundForm.commodityPrice4" placeholder="请输入商品价格"
            class="form-inp-width"></el-input>
        </el-form-item>
        <el-form-item label="手机IMEI码5：" prop="SNName5" v-show="simpleList >= 5">
          <el-input v-model="productOutboundForm.SNName5" placeholder="请输入手机IMEI码" class="form-inp-width"></el-input>
        </el-form-item>
        <el-form-item label="商品价格：" prop="commodityPrice5" v-show="simpleList >= 5">
          <el-input v-model="productOutboundForm.commodityPrice5" placeholder="请输入商品价格"
            class="form-inp-width"></el-input>
        </el-form-item>
        <el-form-item label="手机IMEI码6：" prop="SNName6" v-show="simpleList >= 6">
          <el-input v-model="productOutboundForm.SNName6" placeholder="请输入手机IMEI码" class="form-inp-width"></el-input>
        </el-form-item>
        <el-form-item label="商品价格：" prop="commodityPrice6" v-show="simpleList >= 6">
          <el-input v-model="productOutboundForm.commodityPrice6" placeholder="请输入商品价格"
            class="form-inp-width"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-show="simpleList <= 5" plain @click="toIncrease">增加出库商品</el-button>
          <el-button v-if="
            simpleList >= 2" type="primary" plain @click="toReduce">删除出库商品</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose" type="warning" plain>取 消</el-button>
        <!-- <el-button size="small" @click="handleSubmit">提 交</el-button> -->
        <!-- <el-button size="small" @click="print(outBoundPrintData)">打印出库标签</el-button> -->
        <!-- <el-button size="small" @click="queryPhoneDetail()">查询手机详情</el-button> -->
        <el-button size="small" @click="queryPhoneDetail()" type="primary"
          v-loading.fullscreen.lock="fullscreenLoading">提交并打印</el-button>
      </div>
    </el-dialog>
    <el-dialog @close="handleClose" :title="accessoryOutboundFormTitle" center :visible.sync="accessoryOutboundVisible"
      width="450px" :close-on-click-modal="false">
      <el-form size="small" :model="accessoryOutboundForm" ref="accessoryOutboundForm" :label-width="formLabelWidth">
        <el-form-item label="配件编码：" prop="outParts">
          <el-input type="textarea" v-model="accessoryOutboundForm.outParts" class="form-inp-width"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleAccessoryClose" type="warning" plain>取 消</el-button>
        <!-- <el-button size="small" @click="handleSubmit">确 定</el-button> -->
        <!-- <el-button size="small" @click="print(outBoundPrintData)">打印出库标签</el-button> -->
        <!-- <el-button size="small" @click="queryPhoneDetail()">查询手机详情</el-button> -->
        <el-button size="small" @click="handleAccessorySubmit()" type="primary">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Socket from "@/utils/Socket";
import NMPrintSocket from "@/utils/Print";
import { outBoundPrintData } from "@/utils/printData/outBoundText";
export default {
  data() {
    const jsonObj = {
      printerImageProcessingInfo: {
        printQuantity: 1,
      },
    };
    return {
      fullscreenLoading: false,
      phoneBatchPrintList: [],
      simpleList: 1,
      jsonObj,
      outBoundPrintData,
      phoneForm: {},
      props: {
        value: [String, Number],
      },
      tableData: [],
      formLabelWidth: "110px",
      productOutboundFormTitle: "手机出库",
      accessoryOutboundFormTitle: "配件出库",
      productOutboundVisible: false,
      accessoryOutboundVisible: false,
      productOutboundForm: {},
      accessoryOutboundForm: {},
      hasChildren: true, // 标记为有子节点
      children: [], // 实际应用中，子节点数据可能通过异步加载获取
      userId: 1940693,
    };
  },
  mounted() {
    // 创建socket实例
    const socketData = new Socket("ws://127.0.0.1:37989");

    socketData.open(
      (openBool) => {
        console.log(openBool, "openBool");
        this.printSocketOpen = openBool;
      },
      (msg) => {
        if (msg.resultAck.callback != undefined) {
          const callbackName = msg.resultAck.callback.name;
          const msgInfo = msg.resultAck.info;
          if (callbackName == "onCoverStatusChange") {
            //盒盖状态：0-闭合、1-打开
            console.log("盒盖状态", msgInfo.capStatus);
          } else if (callbackName == "onElectricityChange") {
            //"power" : 0-4, // 电池电量等级（共5档）
            console.log("电池电量等级", msgInfo.power);
          }
        }
      }
    );
    // 创建打印实例
    this.nMPrintSocket = new NMPrintSocket(socketData);
  },
  created() {
    this.queryOrderList();
    // this.queryPhoneDetail();
    this.login();
  },
  methods: {
    login() {
      const currentUrl = window.location.toString();
      const urlObject = new URL(currentUrl);
      const searchParams = new URLSearchParams(urlObject.search);
      const userId = searchParams.get("qfExtUserId");
      if (userId != null || userId != undefined) {
        this.userId = userId;
      }
      console.log("userid:", this.userId);
      // 创建一个新的 Axios 实例专用于 /orderListApi 请求
      const loginApiInstance = axios.create({
        baseURL: "/loginApi",
      });
      //使用FormData对象发送POST请求
      loginApiInstance
        .get("monkeyshop/user/login/" + this.userId)
        .then((res) => {
          // this.tableData = res.data.data;
          if (res.data.code == 200) {
          } else {
            alert(res.data.msg);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleCancel() { },
    toIncrease() {
      console.log(this.simpleList);
      let simpleList = parseInt(this.simpleList) + 1;
      console.log(simpleList);
      this.simpleList = simpleList;
      console.log(this.simpleList);
    },
    toReduce() {
      console.log(this.simpleList);
      if (this.simpleList == 2) {
        console.log(this.simpleList);
        (this.productOutboundForm.SNName2 = ""),
          (this.productOutboundForm.commodityPrice2 = ""),
          (this.simpleList = parseInt(this.simpleList) - 1);
        console.log("这是第2个");
      } else if (this.simpleList == 3) {
        (this.productOutboundForm.SNName3 = ""),
          (this.productOutboundForm.commodityPrice3 = ""),
          (this.simpleList = parseInt(this.simpleList) - 1);
        console.log("这是第3个");
      } else if (this.simpleList == 4) {
        (this.productOutboundForm.SNName4 = ""),
          (this.productOutboundForm.commodityPrice4 = ""),
          (this.simpleList = parseInt(this.simpleList) - 1);
        console.log("这是第4个");
      } else if (this.simpleList == 5) {
        (this.productOutboundForm.SNName5 = ""),
          (this.productOutboundForm.commodityPrice5 = ""),
          (this.simpleList = parseInt(this.simpleList) - 1);
        console.log("这是第5个");
      } else if (this.simpleList == 6) {
        (this.productOutboundForm.SNName6 = ""),
          (this.productOutboundForm.commodityPrice6 = ""),
          (this.simpleList = parseInt(this.simpleList) - 1);
        console.log("这是第六个");
      }
    },
    async print(content) {
      this.fullscreenLoading = true;
      const allPrintersRes = await this.nMPrintSocket.getAllPrinters();
      try {
        if (allPrintersRes.resultAck.errorCode === 0) {
          const allPrinters = JSON.parse(allPrintersRes.resultAck.info);
          const allPrintersName = Object.keys(allPrinters);
          const allPrintersValue = Object.values(allPrinters);

          const res = await this.nMPrintSocket.selectPrinter(
            allPrintersName[0],
            parseInt(allPrintersValue[0])
          );

          if (res.resultAck.errorCode === 0) {
            console.log("连接成功");
            const initRes = await this.nMPrintSocket.initSdk({ fontDir: "" });
            if (initRes.resultAck.errorCode == 0) {
              console.log("初始化成功");
              this.startBatchPrintJobTest(content);
            } else {
              this.fullscreenLoading = false
              this.$notify.error({
                title: '错误',
                message: '初始化失败'
              });
              console.log("初始化失败");
            }
          } else {
            this.fullscreenLoading = false
            this.$notify.error({
              title: '错误',
              message: '连接失败'
            });
            console.log("连接失败");
            alert("连接失败");
          }
        } else {
          this.fullscreenLoading = false
          return alert("没有在线的打印机");
        }
      } catch (err) {
        return alert(err);
      }
    },
    // 开始打印
    // async startPrintJobTest(content) {
    // // console.log(content,'----------打印内容-------------')
    //     if (!this.printSocketOpen) return alert("打印服务未开启");
    //     let contentArr = [];
    //     contentArr.push(content);
    //     this.batchPrintJob(contentArr);
    // },
    // 开始批量打印
    async startBatchPrintJobTest(content) {
      console.log(content, "content");
      // console.log(this.batchPrintData.data,'batchPrintData')
      // this.batchPrintData.data = content
      if (!this.printSocketOpen) return alert("打印服务未开启");
      if (content == null || content.length == 0) {
        return;
      }
      this.batchPrintJob(content);
    },
    //批量打印列表数据
    async batchPrintJob(list) {
      const printQuantity =
        this.jsonObj.printerImageProcessingInfo.printQuantity;
      try {
        const startRes = await this.nMPrintSocket.startJob(
          this.density,
          this.label_type,
          this.print_mode,
          list.length * printQuantity
        );
        if (startRes.resultAck.errorCode == 0) {
          // 提交打印任务
          await this.printTag(list, 0);
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 绘制打印标签
    async printTag(list, x, isPreview) {
      console.log(list, x, isPreview, "绘制打印标签isPreview");
      //设置画布尺寸
      try {
        const res = await this.nMPrintSocket.InitDrawingBoard(
          list[x].InitDrawingBoardParam
        );
        if (res.resultAck.errorCode != 0) {
          return;
        }
        // 提交打印任务
        this.printItem(list, x, list[x].elements, 0, isPreview);
      } catch (err) {
        console.error(err);
      }
    },
    async printItem(list, x, item, i, isPreview) {
      console.log(isPreview, "printItem isPreview");
      try {
        if (i < item.length) {
          let arrParse;
          switch (item[i].type) {
            case "text":
              //绘制文本
              arrParse = await this.nMPrintSocket.DrawLableText(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
            case "qrCode":
              arrParse = await this.nMPrintSocket.DrawLableQrCode(item[i].json);
              //绘制二维码
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
            case "barCode":
              //绘制一维码
              arrParse = await this.nMPrintSocket.DrawLableBarCode(
                item[i].json
              );
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
            case "line":
              //绘制线条
              arrParse = await this.nMPrintSocket.DrawLableLine(item[i].json);
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
            case "graph":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableGraph(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }

              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
            case "image":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableImage(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
          }
        } else {
          console.log(isPreview, "isPreview我到这里了");
          if (isPreview) {
            console.log(isPreview, "isPreview我到这里了");
            // const res = this.nMPrintSocket.generateImagePreviewImage(8)
            // console.log(res, "generateImagePreviewImageRes");
            const res = await this.nMPrintSocket.generateImagePreviewImage(8);
            console.log(res, "----------preImgRes---------");
            //预览图生成失败退出流程
            if (res.resultAck.result != 0) {
              return;
            }
            this.previewImg =
              "data:image/jpeg;base64," +
              JSON.parse(res.resultAck.info).ImageData;
            console.log(this.previewImg, "this.previewImg请求成功");
          }
          //遍历完成，开始打印
          const commitRes = await this.nMPrintSocket.commitJob(
            null,
            JSON.stringify(this.jsonObj)
          );
          //回调页码为数据总长度且回调打印份数数据等于当前页需要打印的份数数据时，结束打印任务
          if (
            commitRes.resultAck.printQuantity == list.length &&
            commitRes.resultAck.onPrintPageCompleted ==
            this.jsonObj.printerImageProcessingInfo.printQuantity
          ) {
            //结束打印任务
            const endRes = await this.nMPrintSocket.endJob();
            if (endRes.resultAck.errorCode === 0) {
              console.log("打印完成");
              this.handleSubmit();
              this.productOutboundVisible = false;
              // socketData.close()
            }
            return;
          }
          //回调为提交成功，同时数据未发送完成时，可继续提交数据
          if (commitRes.resultAck.errorCode === 0 && x < list.length - 1) {
            //数据提交成功，数据下标+1
            console.log("发送下一页打印数据： ");
            x++;
            await this.printTag(list, x);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    queryOrderList() {
      // 创建一个新的 Axios 实例专用于 /orderListApi 请求
      const orderListApiInstance = axios.create({
        baseURL: "/orderListApi",
        headers: {
          "Content-Type": "application/json",
        },
      });
      let params = {
        userId: this.userId,
      };
      //使用FormData对象发送POST请求
      orderListApiInstance
        .post("monkeyshop/platFormOrder/getOrderList", params)
        .then((res) => {
          console.log(res, "res");
          this.tableData = res.data.data.data.getList;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleClose() {
      this.productOutboundVisible = false;
      // this.$refs.productOutboundForm.resetFields();
      this.productOutboundForm = {};
      this.simpleList = 1;
    },
    handleAccessoryClose() {
      this.accessoryOutboundVisible = false;
      this.accessoryOutboundForm = {};
      this.simpleList = 1;
    },
    productOutbound(row) {
      this.productOutboundForm = { ...row };
      this.productOutboundVisible = true;
    },
    accessoryOutbound(row) {
      this.accessoryOutboundForm = { ...row };
      this.accessoryOutboundVisible = true;
    },
    queryPhoneDetail() {
      var that = this;
      that.phoneBatchPrintList = [];
      const phoneCodeList = [];
      for (let index = 1; index <= that.simpleList; index++) {
        phoneCodeList.push(this.productOutboundForm["SNName" + index]);
      }
      console.log(phoneCodeList, "phoneCodeList");
      phoneCodeList.forEach((element) => {
        const outBoundApiInstance = axios.create({
          baseURL: "/outBoundApi",
        });
        //使用FormData对象发送POST请求
        outBoundApiInstance
          .post(
            "monkeyshop/common/getPhoneInfoByImei" +
            "?" +
            "imei" +
            "=" +
            element + "&userId=" +
            this.userId
          )
          .then((res) => {
            console.log(
              res.data.data.phoneVOList,
              "获取单条数据详细信息"
            );
            let detailData = res.data.data.phoneVO;
            
            that.$set(that.phoneForm, "phoneName", detailData.phoneName);

            that.$set(that.phoneForm, "phoneColor", detailData.phoneColor);

            that.$set(that.phoneForm, "phoneMemory", detailData.phoneMemory);

            that.$set(that.phoneForm, "phoneElectricityList", detailData.phoneElectricityList);

            that.$set(that.phoneForm, "phoneOld", detailData.phoneOld);

            that.$set(that.phoneForm, "SNName", detailData.snName);
            const outBoundData = {
              InitDrawingBoardParam: {
                width: 70,
                height: 50,
                rotate: 90,
                path: "ZT001.ttf",
                verticalShift: 0,
                HorizontalShift: 0,
              },

              elements: [
                {
                  type: "text",
                  json: {
                    x: 1,
                    y: 1,
                    height: 6.4,
                    width: 66,
                    value: "上海芒可亿科技有限公司",
                    fontFamily: "宋体",
                    rotate: 0,
                    fontSize: 4.6,
                    textAlignHorizonral: 1,
                    textAlignVertical: 1,
                    letterSpacing: 0.0,
                    lineSpacing: 1.0,
                    lineMode: 6,
                    fontStyle: [true, false, false, false],
                  },
                },

                {
                  type: "text",
                  json: {
                    x: 3,
                    y: 7,
                    height: 3.3,
                    width: 64,
                    value: "型号：iPhone 13ProMax",
                    fontFamily: "宋体",
                    rotate: 0,
                    fontSize: 3.2,
                    textAlignHorizonral: 0,
                    textAlignVertical: 1,
                    letterSpacing: 0.0,
                    lineSpacing: 1.0,
                    lineMode: 6,
                    fontStyle: [false, false, false, false],
                  },
                },
                {
                  type: "text",
                  json: {
                    x: 3,
                    y: 12,
                    height: 3.3,
                    width: 64,
                    value: "颜色：银色",
                    fontFamily: "宋体",
                    rotate: 0,
                    fontSize: 3.2,
                    textAlignHorizonral: 0,
                    textAlignVertical: 1,
                    letterSpacing: 0.0,
                    lineSpacing: 1.0,
                    lineMode: 6,
                    fontStyle: [false, false, false, false],
                  },
                },
                {
                  type: "text",
                  json: {
                    x: 3,
                    y: 17,
                    height: 3.3,
                    width: 64,
                    value: "内存：512G",
                    fontFamily: "宋体",
                    rotate: 0,
                    fontSize: 3.2,
                    textAlignHorizonral: 0,
                    textAlignVertical: 1,
                    letterSpacing: 0.0,
                    lineSpacing: 1.0,
                    lineMode: 6,
                    fontStyle: [false, false, false, false],
                  },
                },
                {
                  type: "text",
                  json: {
                    x: 3,
                    y: 22,
                    height: 3.3,
                    width: 64,
                    value: "电容：94%",
                    fontFamily: "宋体",
                    rotate: 0,
                    fontSize: 3.2,
                    textAlignHorizonral: 0,
                    textAlignVertical: 1,
                    letterSpacing: 0.0,
                    lineSpacing: 1.0,
                    lineMode: 6,
                    fontStyle: [false, false, false, false],
                  },
                },
                {
                  type: "text",
                  json: {
                    x: 3,
                    y: 27,
                    height: 3.3,
                    width: 64,
                    value: "成色：99新",
                    fontFamily: "宋体",
                    rotate: 0,
                    fontSize: 3.2,
                    textAlignHorizonral: 0,
                    textAlignVertical: 1,
                    letterSpacing: 0.0,
                    lineSpacing: 1.0,
                    lineMode: 6,
                    fontStyle: [false, false, false, false],
                  },
                },
                {
                  type: "text",
                  json: {
                    x: 3,
                    y: 32,
                    height: 3.3,
                    width: 64,
                    value: "序列号：KJCBSI29JS",
                    fontFamily: "宋体",
                    rotate: 0,
                    fontSize: 3.2,
                    textAlignHorizonral: 0,
                    textAlignVertical: 1,
                    letterSpacing: 0.0,
                    lineSpacing: 1.0,
                    lineMode: 6,
                    fontStyle: [false, false, false, false],
                  },
                },
                {
                  type: "barCode",
                  json: {
                    x: 3,
                    y: 39,
                    height: 8.3,
                    width: 50,
                    value: "6917633767712816899",
                    codeType: 20,
                    rotate: 0,
                    fontSize: 3.2,
                    textPosition: 0,
                    // textAlignHorizonral: 0,
                    // textAlignVertical: 1,
                  },
                },
              ],
            };
            console.log(that.phoneForm, "phonefoem-------打印前赋值");
            outBoundData.elements[1].json.value =
              "型号：" + this.phoneForm.phoneName;
            outBoundData.elements[2].json.value =
              "颜色：" + this.phoneForm.phoneColor;
            outBoundData.elements[3].json.value =
              "内存：" + this.phoneForm.phoneMemory;
            outBoundData.elements[4].json.value =
              "电容：" + this.phoneForm.phoneElectricityList;
            outBoundData.elements[5].json.value =
              "成色：" + this.phoneForm.phoneOld;
            outBoundData.elements[6].json.value =
              "序列号：" + this.phoneForm.SNName;
            outBoundData.elements[7].json.value =
              this.productOutboundForm.orderId;
            that.phoneBatchPrintList.push(outBoundData);
            console.log(that.phoneBatchPrintList, "that.phoneBatchPrintList");
            that.print(that.phoneBatchPrintList);
          })
          .catch(function (error) {
            console.log(error);
          });
      });
    },
    handleAccessorySubmit() {
      console.log(this.accessoryOutboundForm, "this.accessoryOutboundForm");
      var accessories = this.accessoryOutboundForm.outParts.split('\n')
      console.log(accessories, 'accessories')
      const outParts = accessories.filter(item => item !== '');
      console.log(outParts, 'outParts')
      const outBoundApiInstance = axios.create({
        baseURL: "/outBoundApi",
        "Content-Type": "application/json",
      });
      let params = {
        userId: this.userId,
        orderSource: this.accessoryOutboundForm.type,
        outType: 2,
        orderId: this.accessoryOutboundForm.orderId,
        outParts: outParts,
      };
      //使用FormData对象发送POST请求
      console.log(params, "params");
      outBoundApiInstance
        .post("monkeyshop/common/outbound", params)
        .then((res) => {
          console.log(res, "res");
          this.accessoryOutboundForm = {};
          this.accessoryOutboundVisible = false;
          this.$message({
            message: "配件出库成功",
            type: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleSubmit() {
      console.log(this.productOutboundForm, "this.productOutboundForm");
      const outBoundApiInstance = axios.create({
        baseURL: "/outBoundApi",
        "Content-Type": "application/json",
      });
      console.log(this.simpleList);
      let x = [];
      for (let index = 1; index <= this.simpleList; index++) {
        // this.productOutboundForm.SNName2 = '',
        // this.productOutboundForm.commodityPrice2 ='',
        x.push({
          snName: this.productOutboundForm["SNName" + index],
          commodityPrice: this.productOutboundForm["commodityPrice" + index],
        });
      }
      console.log(x);
      console.log(this.simpleList);
      let params = {
        userId: this.userId,
        orderSource: this.productOutboundForm.type,
        outType: 1,
        orderId: this.productOutboundForm.orderId,
        snCodes: x,
        // outParts: this.productOutboundForm.outParts,
      };
      //使用FormData对象发送POST请求
      console.log(params, "params");
      outBoundApiInstance
        .post("monkeyshop/common/outbound", params)
        .then((res) => {
          console.log(res, "res");

          this.productOutboundForm = {};
          this.productOutboundVisible = false;
          this.$message({
            message: "手机出库成功",
            type: "success",
          });
          this.fullscreenLoading = false;
          this.queryOrderList();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleConfirm(row) {
      console.log(row.name);
      // 创建一个新的 Axios 实例专用于 /orderListApi 请求
      const outBoundApiInstance = axios.create({
        baseURL: "/outBoundApi",
      });

      //使用FormData对象发送POST请求
      //  console.log(params,'params')
      outBoundApiInstance
        .post(
          "monkeyshop/platFormOrder/OrderReturnRequest" +
          "?" +
          "orderId" +
          "=" +
          row.orderId + "&userId=" +
          this.userId
        )
        .then((res) => {
          console.log(res, "res");
          this.$message({
            message: "退货申请成功",
            type: "success",
          });
          this.queryOrderList()
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.skuList {
  border: solid 1px #ced4da;
  padding: 5px;
}

.form-inp-width {
  width: 250px;
}

.el-button--primary {
  color: #fff;
  background-color: #fb9337;
  border-color: #fb9337;
}

.el-button--primary.is-plain:focus,
.el-button--primary.is-plain:hover {
  background: #fb9337;
  border-color: #fb9337;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/outBound.vue